import { Switch } from "./Switch";

export const SwitchContainer = Switch;
